var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { NETWORK_ALIASES } from './aliases';
import { NETWORK_KIND_META } from './kindMeta';
import { getActiveDiagram } from '../theme';
export function slugNetworkType(type) {
    return type
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .toLowerCase()
        .replace(/\(.*?\)/g, ' ')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .replace(/_+/g, '_');
}
/** Alias map: slug → canonical kind (covers the full requested device list). */
export function resolveNetworkIconKind(type) {
    var e_1, _a;
    var key = slugNetworkType(type);
    if (NETWORK_ALIASES[key])
        return NETWORK_ALIASES[key];
    try {
        // Match canonical kind names (camelCase → snake_case via slug)
        for (var _b = __values(Object.keys(NETWORK_KIND_META)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var kind = _c.value;
            if (slugNetworkType(kind) === key)
                return kind;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return 'default';
}
export function getNetworkIconMeta(kind) {
    var _a;
    var m = (_a = NETWORK_KIND_META[kind]) !== null && _a !== void 0 ? _a : NETWORK_KIND_META.default;
    return __assign({ kind: kind }, m);
}
/** Full catalog of canonical icons (one per kind). */
export function listNetworkIconKinds() {
    return Object.keys(NETWORK_KIND_META)
        .filter(function (k) { return k !== 'default'; })
        .map(function (kind) { return getNetworkIconMeta(kind); });
}
/** All accepted type aliases (including friendly names). */
export function listNetworkTypeAliases() {
    return Object.keys(NETWORK_ALIASES).sort();
}
export function networkStyleForKind(kind) {
    var _a;
    var cat = getNetworkIconMeta(kind).category;
    var d = getActiveDiagram();
    var fromCat = (_a = d.networkCategories) === null || _a === void 0 ? void 0 : _a[cat];
    if (fromCat)
        return __assign({}, fromCat);
    if (kind === 'router')
        return __assign({}, d.networkRouter);
    if (kind === 'server' || kind === 'vm')
        return __assign({}, d.networkServer);
    if (kind === 'switch' || kind === 'industrialSwitch')
        return __assign({}, d.networkSwitch);
    if (kind === 'desktop' || kind === 'laptop' || kind === 'phone')
        return __assign({}, d.networkClient);
    return __assign({}, d.networkDefault);
}
